export default __webpack_public_path__ + "static/media/cloth_08.4a392295.jpg";